import { parseColor } from '@src/styles/themes/utils';
import { hoverColor } from '@src/styles/utils';
import { darken } from 'polished';
import { css, type DefaultTheme } from 'styled-components';

/**
 * We have separate styles for blotter popups. This became necessary to inject styles with greater specificity in order to override the default styles applied by aggrid.
 */
export const blotterPopupStyles = (theme: DefaultTheme, background?: string) => {
  const parsedColor = background && background !== 'transparent' ? parseColor(theme, background) : undefined;
  const backgroundColor = parsedColor ? parseColor(theme, parsedColor) : theme.backgroundBlotterTableRow;
  const hoverBackgroundColor = parsedColor ? hoverColor(theme, parsedColor) : theme.backgroundBlotterTableRowHover;
  const borderColor = parsedColor ? darken(0.05, parsedColor) : theme.borderColorBlotterTable;

  return css`
    --ag-foreground-color: ${theme.colorTextImportant};
    --ag-background-color: ${backgroundColor};

    // Header
    --ag-header-foreground-color: ${theme.colorBlotterTableHeader};
    --ag-header-background-color: ${backgroundColor};
    --ag-border-color: ${borderColor};
    --ag-subheader-background-color: transparent;
    --ag-subheader-toolbar-background-color: transparent;
    --ag-header-cell-moving-background-color: ${hoverBackgroundColor};

    // Checkbox styling
    --ag-checkbox-checked-color: ${theme.colors.white.default};
    --ag-checkbox-indeterminate-color: ${theme.colors.white.default};
    --ag-checkbox-unchecked-color: ${theme.colorTextDefault};
  `;
};
